import React, { useEffect, useState } from "react"
import Google from "components/Icons/Google"
import { useFormInput } from "utils/inputHandler"
import { useNavigate } from "react-router-dom"
import GoogleLogin from "react-google-login"
import { gapi } from "gapi-script"
import user from "services/user"
import {
  fetchUserCreditionals,
  setToken,
  setUsername,
} from "redux/modules/userDatas/actions"
import { useDispatch } from "react-redux"
import jwtDecode from "jwt-decode"
import auth_dots from "../../assets/images/auth_dots.png"
import { useTranslation } from "react-i18next"
import Login from "./Forms/Login"
import SignUp from "./Forms/SignUp"
import { classNames } from "utils/classNames"
import { useShowAlert } from "hooks/customAlert"
import Spinner from "components/Spinner/FullScreen"
import { validate } from "./Forms/helper"
import Forgot from "./Forms/Forgot"

export default () => {
  const { t } = useTranslation()
  const { success, error } = useShowAlert()
  // const params = useParams()
  const email = useFormInput()
  const password = useFormInput()
  const photo = useFormInput()
  const firstName = useFormInput()
  const code = useFormInput()
  const lastName = useFormInput()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [showPass, setShowPass] = useState(false)
  const [formType, setFormType] = useState("")
  const [step, setStep] = useState("")
  const pathname = localStorage.getItem("pathname")

  useEffect(() => {
    const stepValue = localStorage.getItem("step") || "firstStep"
    const pageValue = localStorage.getItem("formType") || "login"
    setFormType(() => pageValue)
    setStep(() => stepValue)
    return () => {
      localStorage.removeItem("step")
      localStorage.removeItem("formType")
    }
  }, [])

  const onSuccess = (res) => {
    if (Object.keys(res).length > 0) {
      user
        .googleLogin(res)
        .then((response) => {
          const { _id: visitorId } = jwtDecode(response.token)
          localStorage.setItem("visitorId", visitorId)
          localStorage.setItem("mmbs_access_token", response.token)
          dispatch(setToken(response?.token))
          if (visitorId) {
            dispatch(fetchUserCreditionals())
          }
          if (res.profileObj) {
            localStorage.setItem("user", JSON.stringify(res.profileObj))
            dispatch(setUsername(res?.profileObj?.name))
          }
          success(t("login_success"))
        })
        .catch((err) => {
          console.error(err)
          error(t("error_occurred"))
        })
        .finally(() => navigate("/"))
    }
  }
  const clearStates = () => {
    email.onChange("clearState")
    password.onChange("clearState")
    photo.onChange("clearState")
    firstName.onChange("clearState")
    lastName.onChange("clearState")
    code.onChange("clearState")
  }
  const handleSignIn = (payload) => {
    setLoading(() => true)
    const reqBody = {
      ...payload,
    }
    if (validate(reqBody).errors.email) {
      error(validate({ email: reqBody?.email }).errors.email)
      return
      // error(
      //   "Password:" + validate({ password: reqBody?.password }).errors.password
      // )
    }

    user
      .login(reqBody)
      .then((response) => {
        const { _id: visitorId } = jwtDecode(response.token)
        localStorage.setItem("visitorId", visitorId)
        localStorage.setItem("mmbs_access_token", response.token)
        dispatch(setToken(response?.token))
        dispatch(fetchUserCreditionals())
        clearStates()
        navigate(pathname ?? '/')
        localStorage.removeItem("pathname")
      })
      .catch((err) => {
        error(t("user_not_found"))
        console.error(err)
      })
      .finally(() => setLoading(() => false))
  }
  const submitForm = (payload, stepType) => {
    if (stepType === "firstStep") {
      const formData = new FormData()
      for (let field in payload) {
        if (payload[field].value !== "" && field !== "files") {
          formData.append(field, payload[field]?.value)
        }
        if (Object.keys(payload[field]).length && field === "files") {
          formData.append("files", payload[field])
        }
      }
      user
        .authRegister(formData)
        .then((response) => {
          if (response === "success") {
            localStorage.setItem("user-email", payload?.email?.value)
            formTypeHandler("signUp", "secondStep")
            clearStates()
          }
        })
        .catch((err) => {
          if (err.response.status === 409) {
            error(t("auth-error"))
          }
          console.error(err.response.status)
        })
    }
    if (stepType === "secondStep") {
      let userEmail = localStorage.getItem("user-email")
      if (payload.code?.value) {
        user
          .authCreateVerfication({
            email: userEmail,
            verifycode: payload.code?.value,
          })
          .then((response) => {
            const { _id: visitorId } = jwtDecode(response.token)
            localStorage.setItem("visitorId", visitorId)
            localStorage.setItem("mmbs_access_token", response.token)
            dispatch(setToken(response?.token))
            dispatch(fetchUserCreditionals())
            clearStates()
            navigate("/")
            localStorage.removeItem("user-email")
          })
          .catch((err) => {
            error(t("error_occurred"))
            console.error(err)
          })
          .finally(() => setLoading(() => false))
      }
    }
  }
  const onFailure = (err) => {
    console.log("failed", err)
  }
  const handleVerification = (payload, actionType) => {
    setLoading(() => true)
    if (actionType === "firstStep") {
      user
        .create({ email: payload?.email?.value })
        .then((response) => {
          if (response === "success") {
            localStorage.setItem("user-email", payload?.email?.value)
            clearStates()
            formTypeHandler("forgotPassword", "secondStep")
          }
        })
        .catch((err) => {
          console.error(err)
          error(t("email_not_found"))
        })
        .finally(() => setLoading(() => false))
    }
    if (actionType === "secondStep") {
      let userEmail = localStorage.getItem("user-email")
      user
        .authEmailVerfication({
          email: userEmail,
          password: payload?.password?.value,
          verifycode: payload?.code?.value,
        })
        .then(() => {
          localStorage.removeItem("user-email")
          clearStates()
          success(t("success_updated"))
          setFormType(() => "login")
          setStep(() => '')

          navigate("/auth")
        })
        .catch((err) => {
          console.error(err)
          error(t("error_occurred"))
        })
        .finally(() => setLoading(() => false))
    }
  }

  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        scope: "",
      })
    }
    gapi.load("client:auth2", initClient)
  })
  const formTypeHandler = (type, stepName) => {
    localStorage.setItem("formType", type)
    localStorage.setItem("step", stepName)
    setFormType(() => type)
    setStep(() => stepName)
  }

  const form = {
    login: (
      <Login
        actions={{
          showPass,
          setShowPass,
          handleSignIn,
          step,
          formTypeHandler,
        }}
        fields={{
          email,
          password,
        }}
      />
    ),
    signUp: (
      <SignUp
        actions={{
          showPass,
          setShowPass,
          submitForm,
          step,
        }}
        fields={{
          email,
          password,
          photo,
          firstName,
          lastName,
          code,
        }}
      />
    ),
    forgotPassword: (
      <Forgot
        actions={{
          showPass,
          setShowPass,
          handleVerification,
          step,
        }}
        fields={{
          email,
          password,
          code,
        }}
      />
    ),
  }
  if (loading) {
    return <Spinner />
  }
  return (
    <section className="font-[Roboto] relative conatiner w-full 2xl:h-[calc(100vh-80px)] lg:py-24 md:py-20 sm:py-24 py-24 flex justify-center items-center bg-[rgba(57,57,57,.8)]">
      <div className="absolute top-10 left-80 -z-1">
        <img src={auth_dots} alt="" />
      </div>
      <div className="flex z-10 flex-wrap text-white container w-full min-h-[600px] justify-center max-w-6xl 2xl:w-[1192px] xl:w-[1192px] px-10">
        <div
          className={classNames(
            formType === "signUp" && step !== "secondStep"
              ? "w-full rounded-3xl max-w-3xl"
              : "md:w-1/2 w-full rounded-3xl",
            formType === "login" || formType === "forgotPassword"
              ? "md:w-1/2 w-full rounded-r-none"
              : "",
            "shadow-[0.1px_3px_20px_1px_rgba(0,0,0,0.1)] bg-[rgba(0,0,0,0.5)] bg-opacity-20 backdrop-blur-lg  flex flex-col justify-between "
          )}
        >
          {form[formType]}
          <div
            className={classNames(
              "px-16 pb-10 flex justify-center items-center gap-4 text-white",
              formType !== "signUp"
                ? "flex-col"
                : step === "secondStep"
                ? "flex-col"
                : "flex-row"
            )}
          >
            {formType !== "forgotPassword" && (
              <div className="flex flex-wrap justify-center ">
                <GoogleLogin
                  clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}
                  render={(renderProps) => (
                    <button
                      onClick={renderProps?.onClick}
                      disabled={renderProps?.disabled}
                      type="button"
                      className=" border rounded-xl hover:border-[rgba(255,255,255,08)] flex items-center justify-center p-3 gap-4 transition ease-in-out duration-200"
                      rel="noreferrer"
                    >
                      <Google />
                      <span className="font-semibold leading-normal">
                        {t("auth-through-google")}
                      </span>
                    </button>
                  )}
                  buttonText="Login"
                  onSuccess={onSuccess}
                  onFailure={onFailure}
                  cookiePolicy={"single_host_origin"}
                />
              </div>
            )}
            <div className="flex items-center justify-center gap-x-1">
              <h2 className="">
                {t(
                  formType === "login" || formType === "forgotPassword"
                    ? "not-registreted"
                    : "already-signed"
                )}
              </h2>
              <button
                className="hover:underline font-medium text-[color:var(--custom-secondary)] transition ease-in-out duration-200"
                type="button"
                onClick={() => {
                  const typeForm =
                    formType === "login" || formType === "forgotPassword"
                      ? "signUp"
                      : "login"
                  const steptype = typeForm === "signUp" ? "firstStep" : ""
                  formTypeHandler(typeForm, steptype)
                }}
              >
                {t(
                  formType === "login" || formType === "forgotPassword"
                    ? "auth-register"
                    : "auth-login"
                )}
              </button>
            </div>
          </div>
        </div>
        {formType !== "signUp" && (
          <div className="hidden md:flex relative w-full min-h-full md:w-1/2 p-16 justify-start items-start rounded-r-3xl z-20 bg-cover bg-center bg-[url('assets/images/fergana.png')] bg-no-repeat before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:rounded-r-3xl before:z-10 auth_image">
            <div className="z-30 flex flex-col items-start justify-center text-white">
              <h2 className="max-w-sm text-4xl font-medium pt-28">
                {t("auth-welcome")}
              </h2>
              <p className="text-base font-normal pt-9 max-w-[250px]">
                {t("auth-request-to-auth")}
              </p>
            </div>
          </div>
        )}
      </div>
      <div className="absolute bottom-10 right-80 -z-1">
        <img src={auth_dots} alt="" />
      </div>
    </section>
  )
}
